import { ViewColumn } from "@/utils/views/view-column";

export function downloadSelectionAsCSV(obj: any, fileName: string, columns: ViewColumn[]) {

	let values = [];
	for (let item of obj){
		let a = [];
		for (let column of columns) {
			a.push(resolveProperty(item,column));
		}
		values.push(a);
	}

	const rows = [values.join(",")];
	const csv = rows.join("\n");

	console.log(csv);

	const blob = new Blob([csv], { type: "text/txt" });
	const link = document.createElement("a");

	link.href = URL.createObjectURL(blob);
	link.download = fileName;
	link.click();

}

export function resolveProperty(item: any, column: ViewColumn): any {
	let obj = item;
	return obj[column.Property];
}